import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBNavbarLink,
  MDBContainer,
  MDBIcon,
  MDBCollapse,
  MDBNavbarBrand,
} from 'mdb-react-ui-kit';

export default function App({ alwaysVisible = false }) {
  const [openNavSecond, setOpenNavSecond] = useState(alwaysVisible);
  const [headerVisible, setHeaderVisible] = useState(alwaysVisible);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (alwaysVisible) return;
    const check = () => setHeaderVisible(window.scrollY > 10);
    window.addEventListener('scroll', check, { passive: true });
    check();
    return () => window.removeEventListener('scroll', check);
  }, [alwaysVisible]);

  return (
    <>
      {/* Logo visible uniquement quand le header est caché */}
      <button onClick={() => navigate('/')} style={{
        position: 'fixed', top: '10px', left: '12px', zIndex: 1001, display: 'block',
        opacity: headerVisible ? 0 : 1,
        pointerEvents: headerVisible ? 'none' : 'auto',
        transition: 'opacity 0.4s ease',
        background: 'none', border: 'none', padding: 0, cursor: 'pointer',
      }}>
        <img
          src='/logo_sh_orange.png'
          alt='Logo'
          style={{ height: '10vh', maxHeight: '60px', width: 'auto' }}
        />
      </button>

    <MDBNavbar expand='lg' light
      style={{
        backgroundColor: "rgba(33, 46, 79, 1)",
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 1000,
        transform: headerVisible ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 0.4s ease',
      }}>
      <MDBContainer fluid>
        <MDBNavbarBrand style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img
            src='/logo_sh_orange.png'
            alt='Logo'
            style={{ height: '10vh', maxHeight: '60px', width: 'auto' }}
          />
        </MDBNavbarBrand>
        <MDBNavbarToggler
          aria-expanded='false'
          aria-label='Toggle navigation'
          onClick={() => setOpenNavSecond(!openNavSecond)}
        >
          <MDBIcon icon='bars' fas />
        </MDBNavbarToggler>
        <MDBCollapse navbar open={openNavSecond}>
          <MDBNavbarNav>
            <MDBNavbarLink href='#' onClick={(e) => { e.preventDefault(); if (location.pathname === '/') { window.scrollTo({ top: 0, behavior: 'smooth' }); } else { navigate('/', { state: { scrollTop: true } }); } }} className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace', borderBottom: location.pathname === '/' ? '2px solid #4A9E47' : '2px solid transparent', paddingBottom: '2px' }}>
              Le Projet
            </MDBNavbarLink>
            <MDBNavbarLink href='#' onClick={(e) => { e.preventDefault(); navigate('/actualites'); }} className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace', borderBottom: location.pathname === '/actualites' ? '2px solid #4A9E47' : '2px solid transparent', paddingBottom: '2px' }}>Actualités</MDBNavbarLink>
            <MDBNavbarLink href='#' onClick={(e) => { e.preventDefault(); navigate('/don-organes'); }} className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace', borderBottom: location.pathname === '/don-organes' ? '2px solid #4A9E47' : '2px solid transparent', paddingBottom: '2px' }}>Le don d'organes</MDBNavbarLink>
          </MDBNavbarNav>
        </MDBCollapse>
        {/*<a
          href="https://data.sh-courseaularge.fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <MDBBtn 
          outline
            color="warning" // couleur = orange
            style={{
              borderRadius: "5px", // arrondi
              borderWidth: "3px",
              marginRight: "10rem",
              color: "white", // texte blanc
              borderColor: "#4A9E47", // bordure orange
              backgroundColor: "transparent",
            }}>
            Cartographie Live & Reports
          </MDBBtn>
        </a>*/}
      </MDBContainer>
    </MDBNavbar>
    </>
  );
}